var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbcdGoldGiftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FFC83F",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7852 6.62576C9.68266 6.61992 8.60933 7.68159 9.09933 8.99992H7.25016C6.94074 8.99992 6.644 9.12284 6.4252 9.34163C6.20641 9.56042 6.0835 9.85717 6.0835 10.1666V11.3333C6.0835 11.488 6.14495 11.6363 6.25435 11.7457C6.36375 11.8551 6.51212 11.9166 6.66683 11.9166H11.9168V10.1666H13.0835V11.9166H18.3335C18.4882 11.9166 18.6366 11.8551 18.746 11.7457C18.8554 11.6363 18.9168 11.488 18.9168 11.3333V10.1666C18.9168 9.85717 18.7939 9.56042 18.5751 9.34163C18.3563 9.12284 18.0596 8.99992 17.7502 8.99992H15.901C16.5835 7.09242 14.0168 5.74492 12.8327 7.38992L12.5002 7.83326L12.1677 7.37826C11.8002 6.85909 11.2927 6.63159 10.7852 6.62576ZM10.7502 7.83326C11.2693 7.83326 11.5318 8.46326 11.1643 8.83076C10.7968 9.19826 10.1668 8.93576 10.1668 8.41659C10.1668 8.26188 10.2283 8.11351 10.3377 8.00411C10.4471 7.89471 10.5955 7.83326 10.7502 7.83326ZM14.2502 7.83326C14.7693 7.83326 15.0318 8.46326 14.6643 8.83076C14.2968 9.19826 13.6668 8.93576 13.6668 8.41659C13.6668 8.26188 13.7283 8.11351 13.8377 8.00411C13.9471 7.89471 14.0955 7.83326 14.2502 7.83326ZM6.66683 12.4999V17.1666C6.66683 17.476 6.78975 17.7728 7.00854 17.9915C7.22733 18.2103 7.52408 18.3333 7.8335 18.3333H17.1668C17.4762 18.3333 17.773 18.2103 17.9918 17.9915C18.2106 17.7728 18.3335 17.476 18.3335 17.1666V12.4999H13.0835V17.1666H11.9168V12.4999H6.66683Z",
    fill: "url(#paint0_linear_1_2546)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2546",
    x1: 12.5002,
    y1: 6.62573,
    x2: 12.5002,
    y2: 18.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC433"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbcdGoldGiftIcon);
export default __webpack_public_path__ + "static/media/abcd-gold-gift-icon.c85583f19bbc2ace3301c00ae9564495.svg";
export { ForwardRef as ReactComponent };